// Synthetic source map intentionally exposed for CloudSecIQ testing.